import { render, staticRenderFns } from "./OtherAmendment.vue?vue&type=template&id=a03b09e8"
import script from "./OtherAmendment.vue?vue&type=script&lang=js"
export * from "./OtherAmendment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports